import { useCompany } from "@/context/CompanyContext.jsx";
import { ROLES } from "@/config/roles.js";
import Bills from "./graphs/cards/Bills.jsx";
import ContadorBills from "./graphs/cards/ContadorBills.jsx";

const Dashboard = () => {
  const userRoles = JSON.parse(sessionStorage.getItem("roles")) || [];
  const { selectedCompany } = useCompany();

  const isContador =
    userRoles.includes(ROLES.ADMIN) || userRoles.includes(ROLES.SUPER_ADMIN);

  return (
    <>
      <section className="section dashboard">
        <div className="row m-2">
          {isContador ? (
            <ContadorBills />
          ) : (
            <Bills companyId={selectedCompany} />
          )}
        </div>
      </section>
    </>
  );
};

export default Dashboard;
